import { useContext } from 'react';
import './supHeadDrop.css';
import { useNavigate, useParams } from 'react-router-dom';
import { SupAuthContext } from '../../../../context/SupAuthContext';

export default function SupHeadDrop({ setHeadDrop }) {
    const navigate = useNavigate();
    const { mode } = useParams();
    const { SupLogoutFun } = useContext(SupAuthContext);

    return (
        <div className='supHeadDropDiv' onClick={(e) => e.stopPropagation()}>
            <button
                type='button'
                onClick={() => {
                    navigate(`/support/${mode}/account`);
                    setHeadDrop(false);
                    localStorage.removeItem('ticketUser');
                }}
                name='account'
                className='supHeadDropBtn'
            >
                Account
            </button>
            <button
                type='button'
                onClick={() => {
                    navigate('/support/c/org/account/register');
                    setHeadDrop(false);
                    localStorage.removeItem('ticketUser');
                }}
                name='register'
                className='supHeadDropBtn'
            >
                Register Org
            </button>
            <button
                type='button'
                name='logOut'
                className='supHeadDropBtn'
                onClick={() => {
                    SupLogoutFun();
                    setHeadDrop(false);
                    localStorage.removeItem('ticketUser');
                }}
            >
                Log Out
            </button>
            <button
                type='button'
                name='contactUs'
                className='supHeadDropBtn'
                onClick={() => {
                    navigate('/contact-us');
                    setHeadDrop(false);
                    localStorage.removeItem('ticketUser');
                }}
            >
                Contact Us
            </button>
        </div>
    );
}
